import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import UpgradeHistory from "../components/UpgradeHistory";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpFromBracket, faPlus, faCircleNotch, faXmark } from '@fortawesome/free-solid-svg-icons'
import UpgradeCard from "../components/UpgradeCard";
import { useUser } from "../utils/UserContext";
import Modal from 'react-modal';
import { toast } from 'react-hot-toast';

function Upgradeplan() {
  localStorage.clear();
  const { user } = useUser();  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
          value: coin.name,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const merged = [
      ...crypto,
      ...fiat,
      ...stock
    ];
    setAssethistory(merged);
  }, [crypto, fiat, stock]);
  const [activeTab, setActiveTab] = useState("plans")
  const [plans, setPlans] = useState([]);
  const [history, setHistory] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetch401kPlan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setPlans(data.plans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching plans!')
    })
  }, [user]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchPlanHistory: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrans = data.trans.map(tx => {
        const coinName = tx.method.split(" - ")[0];
        let logo = null;
        let symbol = null;
        const asset = assethistory.find(asset => asset.name === coinName);
        if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
        }
        return {
            ...tx,
            logo,
            symbol
        };
        });
        setHistory(updatedTrans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching history!')
    })
  }, [user]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [disable, setDisable] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [plan_name, setPlan_name] = useState();
  const [planAmount, setPlanAmount] = useState();
  const [max_savings, setMax_savings] = useState();
  const [employer_match, setEmployer_match] = useState();
  const [features, setFeatures] = useState();
  useEffect(() => {
    if(plan_name && max_savings && planAmount && employer_match && features){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [plan_name, max_savings, planAmount, employer_match, features]);
  const AddSubscription = () =>{
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_addplan: true, name : plan_name, amount : planAmount, max_savings : max_savings, employer_match : employer_match, features : features})
    })
    .then(response => response.json())
    .then(data => {
      console.log(data)
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "upgradeplan";
        }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading1(false);
    })
    .catch(err => {
      console.error(err)
      setLoading1(false);
    })
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="401(k) plans" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="401(k) plans" icon={<FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row mt-3">
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center flex-wrap">
                    <h5 className="mb-0 fw-bold text-white ms-2">401(k) Plans</h5>
                    {user?.user_type === "adminface" && (
                    <div className="ms-4 myBtn fe-semibold px-3 rounded-0" onClick={() => setIsOpen(true)} style={{fontSize:'14px'}}><FontAwesomeIcon icon={faPlus} style={{fontSize: '14px'}} className="me-1" /> Add Plan</div>
                    )}
                  </div>
                  <div className="d-flex align-items-cemter overflow-x-auto mx-2" style={{cursor:'pointer'}}>
                    <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "plans" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "plans" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("plans");}}>Plans</h6>
                    <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "history" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "history" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("history");}}>Upgrade history</h6>
                  </div>
                </div>
                {activeTab === "plans" && (
                  <div className="row">
                    {plans.map((plan) => (
                      <div className="col-xxl-3 col-lg-4 col-6 col-12 g-4" key={plan.id}>
                        <UpgradeCard key={plan.id} id={plan.id} name={plan.name} max_savings={plan.max_savings} price={plan.amount} employer_match={plan.employer_match} features={plan.features}/>
                      </div>
                    ))}
                  </div>
                )}
                {activeTab === "history" && (
                  <div className="mycard">
                      <div className="table-responsive">
                          <table className="table table-borderless table-dark align-middle">
                              <thead>
                                  <tr className="fs-7">
                                  <th className="fw-normal text-light d-md-table-cell d-none">ID</th>
                                  <th className="fw-normal text-light d-lg-table-cell d-none">Date</th>
                                  <th className="fw-normal text-light">Plan</th>
                                  <th className="fw-normal text-light d-md-table-cell d-none">Method</th>
                                  <th className="fw-normal text-light">Amount</th>
                                  <th className="fw-normal text-light">Status</th>
                                  <th className="fw-normal text-light d-md-none d-table-cell"></th>
                                  </tr>
                              </thead>
                              <tbody style={{fontSize: '14px'}}>
                              {history.length > 0 ? (
                                  history.map((list, index) => (
                                      <UpgradeHistory index={index} history={list}/>
                                  ))
                              ) : (
                                  <tr>
                                      <td className="py-5" colSpan={6}>You have not made any upgrade yet.</td>
                                  </tr>
                              )}
                              </tbody>
                          </table>
                      </div>
                  </div>
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
      <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode"
      >
        <div className="d-flex align-items-center justify-content-between">
            <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
            Add 401(k) plan</p>
            <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
        </div>
        <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Plan Name:</label>
        <div className="form-control py-2">
            <input 
              type="text"
              placeholder="Lite"
              className="inputNone"
              value={plan_name}
              onChange={(e) => setPlan_name(e.target.value)}
            />
        </div>
        <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
        <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
            <input 
              type="number"
              placeholder="1000"
              className="inputNone"
              value={planAmount}
              onChange={(e) => setPlanAmount(e.target.value)}
            />
            <div
              className="fw-bold text-white d-flex align-items-center"
              style={{
                backgroundColor: 'rgb(30, 33, 36)',
                borderRadius: '4px',
                padding: '6px',
                fontSize: '14px',
                cursor: 'pointer' 
              }}
            >
              USD
            </div>
        </div>
        <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Maximum Savings:</label>
        <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
            <input 
              type="number"
              placeholder="1000"
              className="inputNone"
              value={max_savings}
              onChange={(e) => setMax_savings(e.target.value)}
            />
            <div
              className="fw-bold text-white d-flex align-items-center"
              style={{
                backgroundColor: 'rgb(30, 33, 36)',
                borderRadius: '4px',
                padding: '6px',
                fontSize: '14px',
                cursor: 'pointer' 
              }}
            >
              USD
            </div>
        </div>
        <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Employer Match:</label>
        <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
            <input 
              type="number"
              placeholder="2"
              className="inputNone"
              value={employer_match}
              onChange={(e) => setEmployer_match(e.target.value)}
            />
            <div
              className="fw-bold text-white d-flex align-items-center"
              style={{
                backgroundColor: 'rgb(30, 33, 36)',
                borderRadius: '4px',
                padding: '6px',
                fontSize: '14px',
                cursor: 'pointer' 
              }}
            >
              %
            </div>
        </div>
        <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Features: <small className="text-prime"> * Separate each item on a new line</small></label>
        <textarea 
          className="inputNone form-control w-100"
          value={features}
          onChange={(e) => setFeatures(e.target.value)}
          rows={4}
        />
        <div className={`myBtn w-100 text-center mt-3 bg-prime ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? AddSubscription : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Add Plan'}</div>
      </Modal>
    </div>
  )
}

export default Upgradeplan